import { Builder } from '@builder.io/react'

import { RailDefaults } from '@src/components/Rail/Rail.defaults'
import { imageStyles } from '@src/components/Rail/Rail.props'

import { Rail } from './Rail'

export const railBuilderInputs = [
  {
    name: 'previewMode',
    helperText: 'Displays all items for easy editing',
    type: 'boolean',
    defaultValue: RailDefaults.previewMode,
  },
  {
    name: 'imageStyle',
    friendlyName: 'Image aspect ratio: horizontal, vertical or square.',
    type: 'enum',
    enum: imageStyles,
    defaultValue: imageStyles[0],
  },
  {
    name: 'slug',
    type: 'string',
    helperText: 'Sent to analytics when a CTA is clicked',
    defaultValue: RailDefaults.slug,
    required: true,
  },
  {
    name: 'stackOnMobile',
    type: 'boolean',
    defaultValue: RailDefaults.stackOnMobile,
  },
  {
    name: 'stackOnDesktop',
    type: 'boolean',
    defaultValue: RailDefaults.stackOnDesktop,
  },
  {
    name: 'columnsDesktop',
    friendlyName: 'Number of columns on desktop',
    helperText: 'Suggestion: 4 or 5',
    type: 'number',
    defaultValue: RailDefaults.columnsDesktop,
  },
  {
    name: 'columnsMobile',
    friendlyName: 'Number of columns on mobile',
    helperText: 'Suggestion: 2',
    type: 'number',
    defaultValue: RailDefaults.columnsMobile,
  },
  {
    name: 'blocksTop',
    type: 'array',
    subFields: [
      {
        name: 'blocks',
        type: 'array',
        hideFromUI: true,
      },
    ],
    defaultValue: RailDefaults.blocksTop,
  },
]

Builder.registerComponent(Rail, {
  name: 'Rail',
  inputs: [
    ...railBuilderInputs,
    {
      name: 'items',
      type: 'array',
      subFields: [
        {
          name: 'blocks',
          type: 'array',
          hideFromUI: true,
          defaultValue: RailDefaults.items[0],
        },
      ],
      defaultValue: RailDefaults.items,
    },
  ],
})
